'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var components_BriefDetailBox = require('../../components/BriefDetailBox.js');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject;
var LogoContainer = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  background-color: ", ";\n  height: 35px;\n  width: 60px;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n"])), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return "" + backgroundColor;
});

var HealthFundAccountBox = function HealthFundAccountBox(_ref2) {
  var addonComponent = _ref2.addonComponent,
      backgroundColor = _ref2.backgroundColor,
      cardRank = _ref2.cardRank,
      className = _ref2.className,
      healthFundName = _ref2.healthFundName,
      lastFour = _ref2.lastFour,
      logoBackgroundColor = _ref2.logoBackgroundColor,
      logoUrl = _ref2.logoUrl,
      memberName = _ref2.memberName,
      membershipNumber = _ref2.membershipNumber;
  var cardNumber = null;

  if (membershipNumber) {
    cardNumber = membershipNumber;
  } else if (lastFour) {
    cardNumber = "x" + lastFour;
  }

  return (
    /*#__PURE__*/
    // @ts-expect-error TS(2322): Type '{ children: any[]; className: string; backgr... Remove this comment to see the full error message
    React__default["default"].createElement(components_BriefDetailBox["default"], {
      className: className,
      backgroundColor: backgroundColor,
      justifyContent: "space-between"
    }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React__default["default"].createElement(LogoContainer, {
      backgroundColor: logoBackgroundColor
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: logoUrl,
      alt: healthFundName
    })), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
      marginLeft: "major-2",
      lineHeight: "1.2em"
    }, (cardNumber || memberName) && /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, cardRank && cardRank + " -", " ", cardNumber || memberName), /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
      fontWeight: "semibold"
    }, healthFundName))), addonComponent)
  );
};

HealthFundAccountBox.defaultProps = {
  addonComponent: null,
  backgroundColor: undefined,
  cardRank: '',
  className: '',
  lastFour: null,
  logoBackgroundColor: 'black',
  memberName: null,
  membershipNumber: null
};

exports["default"] = HealthFundAccountBox;
